export enum OrderStatuses {
  NEW = 'NEW',
  CONFIRMED = 'CONFIRMED',
}

export const STATUS_OPTIONS = [
  { id: OrderStatuses.NEW, name: 'Новый' },
  { id: OrderStatuses.CONFIRMED, name: 'Завершенный' },
];
